export default "__VITE_ASSET__t5aEEPss__"